import { render, staticRenderFns } from "./AdShopTermsNotification.vue?vue&type=template&id=2ff42466&"
import script from "./AdShopTermsNotification.vue?vue&type=script&lang=js&"
export * from "./AdShopTermsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports